// Messages exchanged with the Vipps widget SDK parent when embedded as an iframe.
const PARENT_MESSAGE_SOURCE = 'vipps-widget-sdk-parent';
const PARENT_REQUEST_CANCEL_EVENT = 'request-cancel';
const IFRAME_MESSAGE_SOURCE = 'vipps-widget-sdk';
const IFRAME_CANCEL_EVENT = 'cancel';

// Logic originates in the landing page's Header: https://github.com/vippsas/ecom-landing-page-frontend/blob/main/src/components/Header/Header.tsx
export function initWidgetCancelListener(cancel: () => Promise<unknown>): () => void {
  if (window.parent === window) return () => undefined;

  let isCancelling = false;

  const onParentMessage = (event: MessageEvent) => {
    if (
      event.data?.source !== PARENT_MESSAGE_SOURCE ||
      event.data?.event !== PARENT_REQUEST_CANCEL_EVENT
    ) {
      return;
    }

    if (isCancelling) {
      return;
    }
    isCancelling = true;

    void (async () => {
      try {
        await cancel();
      } catch {
        // ignore — we still acknowledge the cancel so the parent can close
      } finally {
        window.parent.postMessage(
          { source: IFRAME_MESSAGE_SOURCE, event: IFRAME_CANCEL_EVENT },
          '*'
        );
        isCancelling = false;
      }
    })();
  };

  window.addEventListener('message', onParentMessage);
  return () => window.removeEventListener('message', onParentMessage);
}
